import dayjs from "dayjs";
import { Therapy } from "../models/therapy.model";

export function is_active_therapy(therapy: Therapy):boolean {
    return dayjs(therapy.start_at).isBefore(dayjs().toDate()) && dayjs(therapy.stop_at).isAfter(dayjs().toDate());
}
export function is_future_therapy(therapy: Therapy):boolean {
    return dayjs(therapy.start_at).isAfter(dayjs().toDate());
}